import React, { useState } from 'react';
import { ChevronDoubleDownIcon } from '@heroicons/react/24/outline';
const CustomLogosCard = ({ image, title, link, onCardClick }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleMouseEnter = () => {
        setIsHovered(true);
    };

    const handleMouseLeave = () => {
        setIsHovered(false);
    };

    return (
        <div
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={onCardClick} // Navigate on click
            className="flex flex-col items-stretch justify-between  text-center cursor-pointer group" // Fixed width
        >
            <div className="relative">
            <div className=" md:h-[50px] h-[25px] w-full ">
                <div className='relative flex justify-center '>
                    <ChevronDoubleDownIcon className="w-6 h-6 md:w-7 md:h-7 text-black absolute top-[0px] opacity-0 group-hover:opacity-100 duration-300 " />
                </div>
            </div>
            </div>
            {image && (
                <img
                    src={image}
                    alt={title || "Image"}
                    className="max-h-40 "
                />
            )}
            <div
                className={"w-full px-4 inline-block bg-custom-yellow group-hover:bg-black duration-300"}  
            >
                <h2 className={"text-sm font-semibold lg:text-lg py-4 group-hover:text-white text-black"}>
                    {title}
                </h2>
            </div>
        </div>
    );
};

export default CustomLogosCard;